
import { HammerGestureConfig } from '@angular/platform-browser';
interface IHammerConfigOverRides {
  [key: string]: object;
}

export class HammerConfig extends HammerGestureConfig {
  public overrides: IHammerConfigOverRides = {
    pan: { threshold:	20 }, // override default settings
  };
}
